import * as React from "react"
import { Row } from "react-grid-system"
import Subtitle from "../../atoms/typography/Subtitle"
import styled from "styled-components"
import { MediaQuery } from "../../../utils/design-helpers"
import H4 from "../../atoms/typography/H4"
import H3 from "../../atoms/typography/H3"
import { useResendActivationEmail } from "../../../hooks/useResendActivationEmail"
import { theme } from "../../../components/theme"
import { HorizontalSpacer } from "../../atoms/spacers"
import PrimaryButton from "../../atoms/buttons/PrimaryButton"
import { CheckCircleIcon } from "../../atoms/icons/CheckCircleIcon"
import { ApolloError } from "@apollo/client"
import { captureExceptionWithContext } from "../../../utils/sentry"

const Content = styled.div`
  padding: 2rem 3rem;
  width: 40vw;

  ${MediaQuery.SM} {
    width: 40vw;
  }

  ${MediaQuery.XS} {
    width: 90vw;
    padding: 1rem;
  }
`

interface Props {
  email: string
  firstName: string
  lastName: string
}

const RegisterCompleted: React.FunctionComponent<Props> = ({ email, firstName, lastName }) => {
  const [emailSent, setEmailSent] = React.useState(false)

  const onCompletedResendActivationEmail = (data: any) => {
    console.log("data: ", data)

    if (!data?.resendActivationEmail?.errors) {
      setEmailSent(true)
      const timer = setTimeout(() => {
        setEmailSent(false)
      }, 3000)
      return () => clearTimeout(timer)
    }
  }
  const onErrorResendActivationEmail = (apolloError: ApolloError) => {
    captureExceptionWithContext(apolloError, "Error in resend activation email")
  }
  const { resendActivationEmail, data, loading } = useResendActivationEmail({
    onCompleted: (data: any) => onCompletedResendActivationEmail(data),
    onError: onErrorResendActivationEmail,
  })
  const onResendActivationEmail = async () => {
    try {
      await resendActivationEmail({
        variables: {
          email: email,
        },
      })
    } catch (error) {
      captureExceptionWithContext(error, "Error in resend activation email")
    }
  }

  return (
    <Row justify="center">
      <Content>
        <HorizontalSpacer spacing={1} />
        <Row justify="center">
          <CheckCircleIcon />
        </Row>
        <HorizontalSpacer spacing={1} />
        <Subtitle textAlign="center">Account successfully registered</Subtitle>
        <HorizontalSpacer spacing={3} />

        <H4 textAlign="center">
          Thank you for registering and welcome to Satcube.com, {firstName} {lastName}!
        </H4>
        <HorizontalSpacer spacing={2} />

        <H3 textAlign="center">
          To activate your account, please verify your email address using the instructions in the email sent to {email}
          .
        </H3>

        <HorizontalSpacer spacing={3} />

        <H3 textAlign="center">Can't find the email?</H3>

        <HorizontalSpacer spacing={3} />

        <Row justify="center">
          <PrimaryButton title="Resend email" onClick={onResendActivationEmail} />
        </Row>

        {emailSent && (
          <div>
            <HorizontalSpacer spacing={2} />
            <Row justify="center">
              <H3 color={theme.colors.greenDark}>Email sent</H3>
            </Row>
          </div>
        )}

        <HorizontalSpacer spacing={1} />
      </Content>
    </Row>
  )
}

export default RegisterCompleted
